import { setCookies, setStringCookie } from "../../../common/functions/cookies";
import { showHideData } from "../../../common/functions/others";

// NOTE: jQuery 3.x では $('selector').ready() がセレクタを無視して全ページで発火するため、
// $(function(){}) + 明示的なページガードに変更する
$(() => {
  if (!$("body.articles.show").length) return;
  setCookies("recently_viewed_articles_ids", gon.article_id);

  /* paramsにviaが含まれていたらcookieに保存
  --------------------------------------------------------- */
  const { via } = $.getParameter();
  if (via) {
    setStringCookie("via", via);
  }

  /* 活動場所の隠れたAreaを表示する
  --------------------------------------------------------- */
  showHideData(".jsShowHideAreasButton", "li.jsHideArea", "jsHideArea");

  /* 活動日程の隠れた日程を表示する
  --------------------------------------------------------- */
  showHideData("#jsShowHideDatasButton", "li.jsHideData", "jsHideData");

  triggerEcommerceViewItem("gtmArticle");
});

function triggerEcommerceViewItem(wrapperId) {
  const event = new CustomEvent("gtm_ecommerce_item_rendering", {
    detail: {
      wrapperSelector: `#${wrapperId}`,
      userType: "person",
    },
  });
  window.dispatchEvent(event);
}
